import { atomWithStorage } from 'jotai/utils';

export const displayVirtualKeyboardAtom = atomWithStorage<boolean>('displayVirtualKeyboard', false);
